import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "@/shapeStorage/shapes/shape";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeIntermediateEventNonInterrupting extends Shape {
    defaultBorderDashType = "dashed";
    defaultBorderWidth = 3;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        const lineWidth = 1.5;
        const marginPercent = 0.15; // 15% от размера

        const oldLineWidth = canv.ctx.lineWidth;
        canv.ctx.lineWidth = lineWidth;

        // Вычисляем пропорциональный отступ
        const horizontalMargin = width * marginPercent;
        const verticalMargin = height * marginPercent;

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width / 2, y + height / 2, width / 2, height / 2, 0, 0, 2 * Math.PI);

        canv.ctx.moveTo(x + width - horizontalMargin, y + height / 2);
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            width / 2 - horizontalMargin,
            height / 2 - verticalMargin,
            0,
            0,
            2 * Math.PI,
        );
        canv.ctx.closePath();

        canv.ctx.lineWidth = oldLineWidth;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "white";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m12 1c1.9945 0 3.8651.53084 5.4781 1.45896m2.0476 1.51829c1.4527 1.36321 2.535 3.11644 3.0797 5.09256m.389 2.57739c.071 2.2513-.5529 4.4166-1.6783 6.2045m-1.4652 1.8531c-1.3912 1.4174-3.1632 2.4597-5.1504 2.9613m-2.7005.3339c-2.08377 0-4.03221-.5794-5.69301-1.5859m-1.90816-1.4628c-1.47056-1.4062-2.55168-3.2163-3.06525-5.2522m-.33358-2.6991c0-2.01453.54154-3.90258 1.48699-5.52651m1.55117-2.06359c1.3927-1.46047 3.18315-2.53829 5.19755-3.05966m-2.01622 5.08296c1.18709-1.02137 2.70482-1.66916 4.37071-1.7609m2.4957.28968c1.6338.48387 3.0297 1.52158 3.9701 2.89561m1.063 2.36991c.14.5659.2143 1.1577.2143 1.7669 0 1.7622-.6216 3.3793-1.6575 4.6438m-2.078 1.7478c-1.0629.5996-2.2904.9417-3.5978.9417-.3491 0-.6924-.0244-1.0284-.0715m-2.43146-.7943c-1.3824-.7411-2.49965-1.9124-3.1727-3.335m-.66728-2.4267c-.1433-1.5005.18105-3.03313.93038-4.34267"
                stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
